// eslint-disable-next-line prettier/prettier
export { default, getStaticProps } from '../../containers/internal-server-error';
